var _defs, _rect, _rect2, _circle, _path, _text, _text2, _rect3, _text3, _text4, _text5, _text6, _text7, _text8, _rect4, _circle2, _text9, _g, _text0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportPageHeroReadyPassportCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 480,
    viewBox: "0 0 900 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Example Work Passport readiness card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-card-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-card-accent"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30D6A1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "wp-card-shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 24,
    floodColor: "#020716",
    floodOpacity: 0.24
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 836,
    height: 420,
    rx: 30,
    fill: "url(#wp-card-bg)",
    stroke: "#BFD8EE",
    filter: "url(#wp-card-shadow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 10,
    height: 420,
    rx: 5,
    fill: "url(#wp-card-accent)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 116,
    r: 40,
    fill: "#E7F8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 116l13 13 25-28",
    fill: "none",
    stroke: "#19AF7C",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 176,
    y: 96,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 850,
    letterSpacing: 2
  }, "WORK PASSPORT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 176,
    y: 137,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 30,
    fontWeight: 850
  }, "Ready for deployment")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 182,
    width: 532,
    height: 1,
    fill: "#D2E1F2"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 226,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, "EMPLOYEE")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 226,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820
  }, "Thabo Mokoena")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 272,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, "SITE")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 272,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820
  }, "North Processing Plant")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 318,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, "POSITION")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 318,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 820
  }, "Maintenance Technician")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 352,
    width: 280,
    height: 52,
    rx: 26,
    fill: "#E7F8F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 378,
    r: 7,
    fill: "#30D6A1"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 384,
    fill: "#08755A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 820
  }, "11 of 11 requirements current")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(678 190)",
    fill: "#07152A"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 0,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 0,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 0,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 0,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 0,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 0,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 19,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 19,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 38,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 38,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 38,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 57,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 57,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 76,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 76,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 76,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 76,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 76,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 95,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 95,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 95,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 95,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 95,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 114,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 114,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 114,
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 114,
    width: 13,
    height: 13,
    rx: 2
  }))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 677,
    y: 354,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 760
  }, "SCAN FOR LIVE STATUS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportPageHeroReadyPassportCard);
export default __webpack_public_path__ + "static/media/work-passport-page-hero-ready-passport-card.016b72ea9d4db7a191daf4b537a999ee.svg";
export { ForwardRef as ReactComponent };